// 正数、负数、小数
export const regNumber = /^(\-|\+)?\d+(\.\d+)?$/;

// 汉字
export const regWordZh = /^[\u4e00-\u9fa5]{0,}$/;
